<template>
    <b-card>
        <b-card-header class="bg-info">
            <h4 class="title">لیست دسترسی ها</h4>
        </b-card-header>
        <b-card-body>
            <b-overlay :show="items.length == 0">
                <b-table
                        :fields="fields"
                        :items="items"
                        hover
                        striped
                >
                    <template #table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> درحال دریافت اطلاعات...</strong>
                        </div>
                    </template>

                    <template #cell(permissions)="data">
                        <b-badge variant="light-info" class="ml-1" v-for="(permission, index) in data.value"
                                 :key="index">{{ permission }}
                        </b-badge>
                    </template>

                    <template #cell(action)="data">
                        <b-dropdown
                                text="عملیات"
                                variant="outline-primary"
                        >
                            <b-dropdown-item :to="{name: 'Permissions_Update', params:{id: data.item.id}}">
                                <feather-icon icon="EditIcon" class="text-warning"/>
                                ویرایش
                            </b-dropdown-item>
                            <b-dropdown-item @click="deletePermission(data.item.id)">
                                <feather-icon icon="XSquareIcon" class="text-danger"/>
                                حذف
                            </b-dropdown-item>
                        </b-dropdown>
                    </template>

                </b-table>
            </b-overlay>
        </b-card-body>
    </b-card>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BDropdown,
    BDropdownItem,
    BOverlay, BPagination
} from 'bootstrap-vue'

export default {
    name: 'Permissions_List',
    components: {
        BPagination,
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BTable,
        BSpinner,
        BBadge,
        BDropdown,
        BDropdownItem,
        BOverlay,

    },
    data() {
        return {
            fields: [
                {
                    key: 'id',
                    label: 'شناسه',
                },
                {
                    key: 'name',
                    label: 'نام دسترسی ',
                },
                {
                    key: 'slug',
                    label: 'نام فارسی دسترسی ',
                },
                {
                    key: 'createdDate',
                    label: 'تاریخ ساخت',
                },
                {
                    key: 'creator',
                    label: 'سازنده',
                },
                {
                    key: 'action',
                    label: 'عملیات',
                }
            ],
            items: [],
            currentPage: 1,
            totalRows: 0,
            perPage: 0
        }
    },
    methods: {
        getPermissionsList() {
            this.$http.get(`user/permissions?page=${this.$route.query.page ?? 1}`)
                .then(({data}) => {
                    if (data.status) {

                        data.permissions.map((permission, index) => {
                            this.items.push({
                                id: permission.id,
                                name: permission.name,
                                slug: permission.slug,
                                createdDate: permission.createdDate,
                                creator: permission.creator,
                            })
                        })
                        this.currentPage = data.meta.current_page
                        this.totalRows = data.meta.total
                        this.perPage = data.meta.per_page
                    } else {
                        this.$bvToast.toast('در دریافت دسترسی ها خطایی رخ داده', {
                            title: 'حطا',
                            toaster: 'b-toaster-top-right',
                            variant: 'danger',
                        })
                    }
                })
                .catch(() => {
                    this.$bvToast.toast('ارتباط با وبسرویس انجام نشد', {
                        title: 'خطا در دریافت اطلاعات',
                        toaster: 'b-toaster-top-right',
                        variant: 'danger'
                    })
                })
        },
        deletePermission(id) {
            this.$swal({
                title: 'حذف گروه دسترسی',
                text: 'آیا از حذف گروه دسترسی مطمئن هستید؟',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'لغو درخواست',
                confirmButtonText: 'حذف گروه دسترسی',
                customClass: {
                    confirmButton: 'btn btn-danger',
                    cancelButton: 'btn btn-success ml-1',
                },
            }).then(result => {
                if (result.value) {
                    this.$swal({
                        title: 'درحال انجام',
                        text: 'لطفا تا دریافت نتیجه منتطر بمانید...',
                        confirmButtonText: 'متوجه شدم'
                    })
                    this.$http.delete(`user/permissions/${id}`)
                        .then(({data}) => {
                            if (data.status) {
                                this.$swal({
                                    title: 'انجام شد',
                                    text: 'دسترسی  با موفقیت حذف شد',
                                    icon: 'success',
                                    confirmButtonText: 'تایید'
                                })
                                this.items = []
                                this.getPermissionsList()
                            } else {
                                this.$swal({
                                    title: 'انجام نشد',
                                    text: 'در حذف دسترسی  خطایی رخ داده',
                                    icon: 'danger',
                                    confirmButtonText: 'تایید'
                                })
                            }
                        })
                        .catch(() => {
                            this.$bvToast.toast('ارتباط با وبسرویس انجام نشد', {
                                title: 'خطا در دریافت اطلاعات',
                                toaster: 'b-toaster-top-right',
                                variant: 'danger'
                            })
                        })
                }
            })
        }
    },
    watch:{
        'currentPage'(newVal, oldVal){
            if (newVal != oldVal){
                this.$router.push({name: 'Permissions_List', query: {page: this.currentPage}})
                this.items = []
                this.getPermissionsList()
            }
        }
    },
    mounted() {
        this.getPermissionsList()
    }
}
</script>

<style>

</style>